import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from './founder/HeroSection';
import { PortraitIntroSection } from './founder/PortraitIntroSection';
import { ExpertiseSections } from './founder/ExpertiseSections';
export function MeetTheFounderPage() {
  return <div className="min-h-screen flex flex-col bg-brand-black" data-id="element-812">
      <Navbar data-id="element-813" />
      <main className="flex-grow pt-[7.25rem]" data-id="element-814">
        <HeroSection data-id="element-815" />
        <PortraitIntroSection data-id="element-816" />
        <ExpertiseSections data-id="element-817" />
      </main>
      <Footer data-id="element-818" />
    </div>;
}